export const USER_AGREEMENT_URL = 'https://yandex.ru/legal/distribution_interface/ru/';

export const DISTRIBUTION_AGREEMENT_URL = 'https://yandex.ru/legal/distribution_test_agreement/ru/';
